import * as React from "react";

import {buildUrlQuery}  from "@Common/utils/build-url-query";
import {parseUrlQuery}  from "@Common/utils/parse-url-query";
import {equalDeep}      from "@Common/utils/objects";

import {postFormHttp}   from "../../product-options/customize-action/post-form-http";


export const RedirectAction = ({apis, companyAllowBuild3, ensureItemAddedToCart, status, item, itemState, isFromApproval, routerHistory, savedState, systemConstants, next}) => next(async ({forceCustomize, templateOptions}) => {
    if(!equalDeep(savedState.value, itemState.value))
    {
        status.updating()
        await apis.next.item.updateItem(itemState.value);
    }
    if(forceCustomize) {
        let specifications = await apis.next.order.getTemplateSpecFields(templateOptions?.sku);
        let allowBuild3 = false;
        let build3SupportedBuildPaths = JSON.parse(systemConstants?.value?.BUILD3_SUPPORTED_BUILDPATHS);
        if(companyAllowBuild3) {
            allowBuild3 = !templateOptions.build_path || build3SupportedBuildPaths.includes(templateOptions?.build_path)
        }
        status.redirecting("Customize")
        if( templateOptions.proofEngineType && ( !allowBuild3 || templateOptions.proofEngineType === 8 ) ) {
            submitLegacyTemplateNew({itemId: item.itemId, type:"updateForceAgent", idComponent: templateOptions?.sku?.front, isFromApproval});
            window.addEventListener("pageshow", () => status.clear(), {once: true});
        }
        else {
            routerHistory.push(`/customize/order/${item.itemId}/${templateOptions?.sku?.front}` + buildUrlQuery({
                ...isFromApproval && {
                    id_cart: parseUrlQuery(location.search)?.id_cart,
                    referrer: "approval-requests"
                },
            }))
        }
    }
    else {
        if( isFromApproval ) {
            const cartId = parseUrlQuery(location.search)?.id_cart;
            status.redirecting("Checkout");
            routerHistory.push(`/checkout/${cartId}?referrer=approval-requests`);
        }
        const {cartId, result, msg} = await ensureItemAddedToCart({
            item,
        });

        if( result==='failure' )
        {
            alert(msg)
            return;
        }
        await apis.next.session.clearSessionOrder();
        routerHistory.push(`/checkout/${cartId}`);
    }
});


const submitLegacyTemplateNew = ({itemId, type, idComponent, isFromApproval}) => {
    postFormHttp("/next/start.php", {
        action: "edit",
        redirect: "customize",
        id_order: itemId,
        order_exists: "exists",
        procform: 1,
        id_component: idComponent,
        ...isFromApproval && {
            approval: 1,
        },
        force_agent_update: ["updateForceAgent", "createNew"].includes(type) ? 1 : 0
    });
};
